export default __webpack_public_path__ + "static/media/marketplace.2c8ae3a5.png";